@if (statusForm) {
  <form class="grid grid-cols-1 gt-sm:grid-cols-2 grid-rows-1 gap-2 justify-stretch" [formGroup]="statusForm">
    <mat-form-field appearance="outline">
      <mat-label>Verification status</mat-label>
      <mat-select formControlName="verificationStatus">
        @for (status of verificationStatuses; track status) {
          <mat-option [value]="status">
            {{ status | sentenceCase }}
          </mat-option>
        }
      </mat-select>
      <mat-error>Required</mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Payment status</mat-label>
      <mat-select formControlName="paymentStatuses" multiple>
        @for (paymentStatus of paymentStatuses; track paymentStatus) {
          <mat-option [value]="paymentStatus">
            {{ paymentStatus | paymentStatus }}
          </mat-option>
        }
      </mat-select>
      <mat-error>Required</mat-error>
    </mat-form-field>
  </form>
} @else {
  <app-loading-spinner></app-loading-spinner>
}
